import apiClient from './api';
import { User } from '../types/user';

/**
 * Interface for the credentials required for login.
 */
export interface LoginCredentials {
  username: string;
  password: string;
}

/**
 * Interface for the token data returned from the API upon successful login.
 */
export interface TokenResponse {
  access: string;
  refresh: string;
}

const login = async (credentials: LoginCredentials): Promise<TokenResponse> => {
  const response = await apiClient.post<TokenResponse>('/token/', {
      username: credentials.username,
      password: credentials.password
  });
  return response.data;
};

const getMe = async (): Promise<User> => {
  const response = await apiClient.get<User>('/users/me/');
  return response.data;
};

export const authService = {
  login,
  getMe,
};